import { useDependencyManagerContext } from 'src/contexts/dependencyManager';

export const useStaticStrings = () => {
  const { translate } = useDependencyManagerContext();

  return {
    fsDataComponentName: 'UserDataField',
    loginDetailsTitle: translate('security.loginDetails', 'Login details'),
    emailLabel: translate('profile.email', 'Email'),
    emptyEmail: translate('profile.noEmail', 'No email'),
    phoneLabel: translate('profile.phone', 'Phone'),
    emptyPhone: translate('profile.noPhone', 'No phone'),
    loginMethodsLabel: translate('security.loginMethods', 'Login methods'),
    emailAndPhoneLabel: translate('security.emailAndPhone', 'Email, Phone'),
    emailAndUsernameLabel: translate(
      'security.emailAndUsername',
      'Email, Username'
    ),
    emailAndPhoneAndUsernameLabel: translate(
      'security.emailAndPhoneAndUsername',
      'Email, Phone, Username'
    ),
    passwordMask: '*************',
    passwordLabel: translate('security.currentPassword', 'Current password'),
    mfaLabel: translate(
      'security.twoFactorAuth.message',
      '2-factor authentication'
    )
  };
};
